query GetDefaultTask {
    taskDefaults {
        id
        title
        description
        dueTime
        assignee {
            id
        }
        isOverdue
        completedTime
        completedByUser {
            id
            name
        }
    }
}
